import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import Layout from '../Components/Layout/Layout';
import { Input } from "@/Components/ui/input";
import { Button } from "@/Components/ui/button"; 
import axiosInstance from '../utils/axiosConfig';
import { foodbookInstance } from '../utils/axiosConfig';
import { ChevronLeft, Plus, Trash2, Carrot, Utensils, CheckCircle2 } from "lucide-react";
import ConfirmationModal from '../Components/Includes/ConfirmationModal';
import AllergensModal from "../Components/Products/AllergensModal";
import ProductModal from "../Components/Products/ProductModal";
import icon1 from '../images/allergens/1.webp';
import icon3 from '../images/allergens/3.webp';
import icon4 from '../images/allergens/4.webp';
import icon5 from '../images/allergens/5.webp';
import icon11 from '../images/allergens/11.webp';
import icon12 from '../images/allergens/12.webp';
import icon16 from '../images/allergens/16.webp';
import icon17 from '../images/allergens/17.webp';
import icon19 from '../images/allergens/19.webp';
import icon21 from '../images/allergens/21.webp';
import icon22 from '../images/allergens/22.webp';
import icon23 from '../images/allergens/23.webp';
import icon24 from '../images/allergens/24.webp';
import icon26 from '../images/allergens/26.webp';
import empty from '../images/allergens/empty.png';

const Product = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { mproductId, productId, returnPage, activeTab } = location.state || {};
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nameError, setNameError] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [success, setSuccess] = useState('');
    const [isProductModalOpen, setIsComponentModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [error, setError] = useState(null); 
    const [product, setProduct] = useState({
        id: null,
        refid: null,
        type: 'homemade',
        name: '',
        description: '',
        allergens: [],
        components: [],
        footprint: 0
    });
    const [isSaving, setIsSaving] = useState(false);

    const allergenIcons = {
        1: icon1,
        3: icon3,
        4: icon4,
        5: icon5,
        11: icon11,
        12: icon12,
        16: icon16,
        17: icon17,
        19: icon19,
        21: icon21,
        22: icon22,
        23: icon23,
        24: icon24,
        26: icon26,
    };


    const handleReturn = () => {
        navigate(`/products`, { state: { activeTab } });
    };

    const handleReturnProduct = () => {
        navigate(`/product`, { state: { productId: mproductId } });
    };

    const handleComponentClick = (componentId) => {
        navigate('/component', {
            state: {
                productId: componentId,
                returnPage: 'product',
                mproductId: productId
            }
        });
    };
     
     
    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setProduct(prevState => ({
            ...prevState,
            [name]: value
        }));
    }, []);

    const handleReOpen = (newId) => {
        navigate('/product', {
            state: {
                productId: newId,
                returnPage,
                activeTab
            }
        });
    };

    useEffect(() => {
        const fetchProduct = async () => {
            if (!productId) {
                setIsLoading(false);
                setError('Geen product ID gevonden');
                return;
            }

            try {
                setIsLoading(true);
                const response = await axiosInstance.get(`/product/GetProduct/${productId}`);
                setProduct(response.data);
            } catch (error) {
                console.error('Error fetching product:', error);
                setError(error.message || 'Er is een fout opgetreden bij het ophalen van het product');
            } finally {
                setIsLoading(false);
            }
        };

        if (productId && productId !== 0) {
            fetchProduct();
        } else {
            setIsLoading(false);
        } 
    }, [productId]);


    const validateForm = () => {
        let isValid = true;
        setNameError(''); 

        if (!product.name.trim()) {
            setNameError('Naam is verplicht');
            isValid = false;
        }
          
        return isValid;
    };

    const handleSave = async () => {
        if (!validateForm()) {
            return;
        }

        try {
            setIsSaving(true);
            setError(null);

            const response = await axiosInstance.post('/product/SetProduct', {
                id: product.id || 0,
                refId: product.refId || 0, // Changed from null
                type: product.type || '', // Send actual type value
                name: product.name,
                description: product.description,
                allergens: product.allergens || [],
                components: product.components || [],
                footprint: product.footprint || 0
            });
            const data = await response.data;

            if (response.status !== 200) {
                throw new Error('Failed to save product');
            } else {
                setShowSuccess(true);
                setSuccess('Product succesvol opgeslagen');

                setTimeout(() => {
                    // Volledige pagina refresh na succesvol opslaan
                    window.location.reload();
                }, 2000);
            }
        } catch (error) {
            console.error('Error saving product:', error);
            setError(error.message || 'Er is een fout opgetreden bij het opslaan');
        } finally {
            setIsSaving(false);
            window.scrollTo({ top: 0, behavior: 'smooth' }); 
        }
    };


    const handleAddComponent = () => {
        setIsComponentModalOpen(true);
    }; 


    const handleSaveCompponent = async (component, type) => {  
        setIsLoading(true);
        if (type === 'Ps') {
            var productSheet = await foodbookInstance.get(`/MenuApp/GetProductSheet/${component.refid}`);
            const allergenInfo = productSheet?.data?.product?.specificationinfolist?.specificationinfo?.allergenset?.allergens?.allergeninfo ?? [];
            const farmtofarm = productSheet?.data?.product?.farmtofarm ?? 0;

            var allergenList = [];
            {
                allergenInfo?.map((allergen) => {
                    if (parseInt(allergen.levelofcontainmentid) === 1) {
                        allergenList.push({
                            id: parseInt(allergen.id),
                            name: allergen.name.value
                        });


                        var allergenExists = product.allergens?.some(existing => existing.id === parseInt(allergen.id));
                        if (!allergenExists) {
                            product.allergens.push({
                                id: parseInt(allergen.id),
                                name: allergen.name.value
                            });
                        }
                    }
                    return null;
                })
            }

            component.farmtofarm = farmtofarm;
            component.allergens = allergenList;
        }

        var response = await axiosInstance.post(`/product/Add${type}Component/${productId}`, component);
        component.id = response.data;


        setProduct(prev => ({
            ...prev,
            components: [...prev.components, component]
        }));

        setIsLoading(false);
    };
     
    const handleSaveAllergens = async (selectedAllergens) => {
        try {
            //await axiosInstance.post(`/product/SetAllergens/${product.id}`, {
            //    ids: selectedAllergens.map(allergen => allergen.Id)
            //});
            setProduct(prev => ({ ...prev, allergens: selectedAllergens }));
        } catch (error) {
            console.error('Error saving dietary needs:', error);
        }
    };


    const handleDeleteProduct = async () => {
        try {
            await axiosInstance.delete(`/product/DeleteProduct/${productId}`);
            navigate('/products');
        } catch (error) {
            console.error('Error deleting product:', error);
            setError(error.message);
        }
    };

    
    const handleRemoveComponent = async (id) => {
        await axiosInstance.delete(`/product/RemoveComponent/${productId}/${id}`);

        const response = await axiosInstance.get(`/product/GetProduct/${productId}`);
        const productData = response.data;

        //setDish(prevDish => ({
        //    ...prevDish,
        //    products: prevDish.products.filter(product => product.id !== productId),
        //    allergens: productData.allergens
        //}));
    }; 
    
    

    const isEditable = product?.refid === null || product?.refid === 0;
    if (isLoading) return <Layout><div>Loading...</div></Layout>;
    if (error) return <Layout><div>Error: {error}</div></Layout>; 


    return (
        <Layout>
            <div className="relative max-w-[1100px] mx-auto">
                <div className="mb-8"> 
                    {location.pathname === '/component' || location.pathname === 'component' ? (
                    <button
                        onClick={handleReturnProduct}
                        className="text-ps-blue-dark hover:underline font-inter"
                    >
                        <ChevronLeft className="float-left" />
                        Terug naar product
                        </button>
                    ) : (
                    <button
                        onClick={handleReturn}
                        className="text-ps-blue-dark hover:underline font-inter"
                    >
                        <ChevronLeft className="float-left" />
                        Terug naar overzicht
                    </button>
                    ) }
                </div>


                {showSuccess && (
                    <div className="mb-4 p-4 bg-green-50 text-green-700 rounded-lg flex items-center gap-2">
                        <CheckCircle2 className="h-5 w-5" />
                        <span className="font-inter">{success}</span>
                    </div>
                )}

                {error && (
                    <div className="mb-4 p-4 bg-red-50 text-red-700 rounded-lg">
                        <span className="font-inter">{error}</span>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="md:col-span-2 space-y-6">


                        {isEditable && (
                            <div className="mb-4">
                                <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                    Type product
                                </label>
                                <div className="flex gap-4">
                                    {[
                                        {
                                            value: 'homemade',
                                            icon: <Carrot className="text-ps-orange mr-2" size={20} />,
                                            label: 'Huisgemaakt'
                                        },
                                        {
                                            value: 'bought',
                                            icon: <Utensils className="text-ps-blue mr-2" size={20} />,
                                            label: 'Gekocht'
                                        }
                                    ].map((option) => (
                                        <label key={option.value} className="flex items-center p-3 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="type"
                                                value={option.value}
                                                checked={product.type === option.value}
                                                onChange={handleChange}
                                                className="mr-2" 
                                            />
                                            {option.icon}
                                            <span>{option.label}</span>
                                        </label>
                                    ))}
                                </div> 
                            </div>
                        )}

                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Naam
                            </label>
                            <Input
                                type="text"
                                name="name"
                                value={product.name}
                                onChange={handleChange}
                                disabled={!isEditable}
                                className={`w-full p-2 border rounded ${isEditable ? 'bg-white' : 'bg-gray-100'}`}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Omschrijving
                            </label>
                            <textarea
                                name="description"
                                value={product.description}
                                onChange={handleChange}
                                disabled={!isEditable}
                                className={`w-full p-2 border rounded h-32 resize-none font-inter ${isEditable ? 'bg-white' : 'bg-gray-100'}`}
                            />
                        </div>

                            <div className="flex justify-end">
                                {(product && productId > 0) ? (
                                    <Button
                                        variant="destructive"
                                        onClick={() => setIsDeleteModalOpen(true)}
                                        className="flex gap-2 w-60 bg-red-700 text-white hover:opacity-80 mr-2"
                                    >
                                        Verwijderen
                                    </Button>
                            ) : (
                                <Button
                                    variant="destructive"
                                    disabled="true"
                                    className="flex gap-2 w-60 bg-gray-700 text-white hover:opacity-80 mr-2"
                                >
                                    Verwijderen
                                </Button>
                            )}
                            {isEditable && (
                                <Button
                                    onClick={handleSave}
                                    disabled={isSaving}
                                    className="bg-ps-blue-dark hover:bg-ps-blue-darker text-white w-60"
                                >
                                    {isSaving ? 'Opslaan...' : 'Opslaan'}
                                </Button>
                            )}
                            </div>
                        <ConfirmationModal
                            isOpen={isDeleteModalOpen}
                            onClose={() => setIsDeleteModalOpen(false)}
                            onConfirm={handleDeleteProduct}
                            title="Verwijder product"
                            message="Weet je zeker dat je dit product wilt verwijderen?"
                        />


                        {isEditable && (
                            <div>
                                <label className="block text-sm font-inter text-ps-blue-dark mb-4">
                                    Componenten
                                </label>

                                <div className="space-y-2">
                                    {product.components && product.components.map((component, index) => (
                                        <div
                                            key={component.id || `component-${index}`} 
                                            className="flex items-center justify-between w-full p-3 hover:pl-6 cursor-pointer border-b-[1px]"
                                            onClick={() => handleComponentClick(component.id)}
                                        >
                                            <span className="font-inter">{component.name}</span>
                                            <div className="flex items-center gap-6">
                                                <Trash2 className="text-ps-pink cursor-pointer" size={20}
                                                    onClick={() => handleRemoveComponent(component.id)} />
                                            </div>
                                        </div>
                                    ))}
                                    <div className="flex justify-end mt-4"> 
                                        {productId !== 0 && (
                                             <>
                                                <Button
                                                    onClick={handleAddComponent}
                                                    className="inline-flex mt-4 items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-ps-green hover:bg-ps-green/90 text-white px-4 py-2 shadow-lg rounded-full"
                                                >
                                                    <Plus className="h-6 w-6" />
                                                    <span>Component toevoegen</span>
                                                </Button>
                                                <ProductModal
                                                    isOpen={isProductModalOpen}
                                                    onClose={() => setIsComponentModalOpen(false)}
                                                    onSave={handleSaveCompponent}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="md:col-span-1">
                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Allergenen
                            </label>
                            {product.allergens && product.allergens.length > 0 && (
                                <div className="flex flex-col pb-2">
                                    {product.allergens
                                        .filter(allergen => allergenIcons[allergen.id])
                                        .map((allergen, index) => (
                                        <div
                                            key={allergen.id || `allergen-${index}`}
                                            className="flex items-center gap-2 p-1"
                                        >
                                            <img
                                                src={allergenIcons[allergen.id] || empty}
                                                alt={allergen.name}
                                                className="w-6 h-6"
                                            />
                                            <span className="font-inter text-sm">{allergen.name}</span>
                                        </div>
                                    ))}

                                    {isEditable && (
                                        <div className="flex justify-end mt-4">
                                            <Button
                                                onClick={() => setIsModalOpen(true)}
                                                className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-ps-green hover:bg-ps-green/90 text-white px-4 py-2 shadow-lg rounded-full"
                                            >
                                                <Plus className="h-6 w-6" />
                                                <span>Allergeen toevoegen</span>
                                            </Button>
                                            <AllergensModal
                                                isOpen={isModalOpen}
                                                onClose={() => setIsModalOpen(false)}
                                                onSave={handleSaveAllergens}
                                                selectedAllergens={product.allergens}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Product;